import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// public/index.html carries fallback SEO tags for non-JS crawlers. Each page sets its
// own via Helmet, so drop the fallbacks to avoid duplicate titles/descriptions.
document.querySelectorAll('[data-fallback-seo]').forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
